import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { MatIconModule } from '@angular/material/icon';
import { DunaLocationInformationComponent } from '../duna-location-information/duna-location-information.component';
import { DynamicTableComponent } from '../../dynamic-table/dynamic-table.component';
import { DunaUserGroupsLocationComponent } from '../duna-user-groups-location/duna-user-groups-location.component';
import { DunaUserGroupsLocationCalendarComponent } from '../duna-user-groups-location-calendar/duna-user-groups-location-calendar.component';
import { DunaReportGeneratorComponent } from '../duna-report-generator/duna-report-generator.component';
import { DunaManualMaintenanceMinutesComponent } from '../duna-manual-maintenance-minutes/duna-manual-maintenance-minutes.component';
import { ComponentDataSourceService } from '../../../services/component-data-source/component-data-source.service';
import { AuthService } from '../../../services/auth/auth.service';
import { UserService } from '../../../services/user/user.service';
import { resolveLocationGuid } from '../../../services/component-data-source/data/groups/duna_user_groups_location';
import { userCanViewUserGroupsLocation } from '../duna-user-groups-location/user-groups-location-access.utils';

@Component({
  selector: 'app-duna-location-page',
  standalone: true,
  imports: [
    MatIconModule,
    DunaLocationInformationComponent,
    DynamicTableComponent,
    DunaUserGroupsLocationComponent,
    DunaUserGroupsLocationCalendarComponent,
    DunaReportGeneratorComponent,
    DunaManualMaintenanceMinutesComponent,
  ],
  templateUrl: './duna-location-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './duna-location-page.component.scss',
})
export class DunaLocationPageComponent implements OnInit {
  groupsEnabled = false;
  canViewReports = false;

  readonly eventsTableInput = {
    dataSource: { type: 'text', value: 'location_events' },
    tableTitle: { type: 'text', value: 'Events' },
    tableDescription: { type: 'textarea', value: '' },
  };

  constructor(
    private dataSourceService: ComponentDataSourceService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private authService: AuthService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    void this.resolveReportAccess();
    const obs = this.dataSourceService.executeDataSource(
      'duna_groups_enabled',
      {}
    );
    if (!obs) {
      return;
    }
    obs.subscribe({
      next: (res: { visible?: boolean }) => {
        this.groupsEnabled = res?.visible === true;
        this.cdr.markForCheck();
      },
      error: () => {
        this.groupsEnabled = false;
        this.cdr.markForCheck();
      },
    });
  }

  private async resolveReportAccess(): Promise<void> {
    const started = Date.now();
    while (Date.now() - started < 5000) {
      if (this.authService.getCurrentUser()) {
        break;
      }
      await new Promise((resolve) => setTimeout(resolve, 100));
    }

    const locationGuid = resolveLocationGuid(this.router);
    let userLocationGuids: string[] = [];
    try {
      const locations = await firstValueFrom(
        this.userService.getUserLocationsFromApi()
      );
      userLocationGuids = (locations ?? []).map((loc) => loc.guid).filter(Boolean);
    } catch {
      userLocationGuids = [];
    }

    this.canViewReports = userCanViewUserGroupsLocation({
      userRoles: this.authService.getUserRoles(),
      locationGuid,
      userLocationGuids,
    });
    this.cdr.markForCheck();
  }
}
